import UI from '/javascripts/utils/UI'
import Flickity from 'flickity'
import bus from '/javascripts/bus'
import { BREAKPOINTS } from '/javascripts/constants/breakpoints'

UI({
  component: '.js-CardSlider',
  slides: '.js-CardSlider-slides',
  heading: '.js-CardSlider-heading',
}, ({ slides, heading }) => {
  const state = { flickity: null }

  setSlidesOffset()
  bus.on('windowResize', setSlidesOffset)

  setupFlickity()
  if (document.readyState !== 'complete') {
    document.addEventListener('readystatechange', ({ target: { readyState } }) => {
      if (readyState === 'complete') setupFlickity()
    })
  }

  function setSlidesOffset() {
    if (heading && window.innerWidth >= BREAKPOINTS.LAPTOP) {
      slides.style.paddingLeft = `${heading.clientWidth + 50}px` // + 50 so we have a little spacing between the slides and the heading
    } else {
      slides.style.paddingLeft = ''
    }
  }

  function setupFlickity() {
    state.flickity && state.flickity.destroy()
    state.flickity = new Flickity(slides, {
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      pageDots: false
    })
  }
})
